import React from "react";
import { TextField } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import LanguageApi from "../components/Language";
import "remixicon/fonts/remixicon.css";
export const Contact = () => {
  const {
    contanct_go,
    contact_go_subtitle,
    name,
    mail,
    number,
    subject,
    message,
    post,
  } = LanguageApi();
  return (
    <div className="form-area">
      <div className="form-area-text">
        <h1>{contanct_go}</h1>
        <p>{contact_go_subtitle}</p>
      </div>
      <div className="form-area-second">
        <div className="form-second-component-1 form-second-component">
          <div className="form-second-component-icon">
            <i class="ri-map-pin-line"></i>
          </div>
          <div className="form-second-component-text">
            <a
              href="https://goo.gl/maps/o7uLQtMccKjNj5Yf7"
              target="_blank"
              rel="noreferrer"
            >
              600 evler mahallesi 1319. Sokak no:52/1 Bandırma/Balıkesir/Turkey
            </a>
          </div>
        </div>
        <div className="form-second-component-2 form-second-component">
          <div className="form-second-component-icon">
            <i class="ri-printer-line"></i>
          </div>
          <div className="form-second-component-text">+90 (266) 721 30 05</div>
        </div>
        <div className="form-second-component-3 form-second-component">
          <div className="form-second-component-icon">
            <i class="ri-phone-line"></i>
          </div>
          <div className="form-second-component-text">
            <a href="tel:02667213000">+90 (266) 721 30 00</a>
          </div>
        </div>
        <div className="form-second-component-4 form-second-component">
          <div className="form-second-component-icon">
            <i class="ri-mail-line"></i>
          </div>
          <div className="form-second-component-text">
            <a href="mailto:info@avenkimyevi.com">info@avenkimyevi.com</a>
          </div>
        </div>
      </div>
      <Box
        component="form"
        method="post"
        action={process.env.REACT_APP_DEF_URL + "contactpost.php"}
        sx={{
          "& > :not(style)": {
            m: 1,
            display: "flex",
            alignItems: "center",
          },
        }}
        noValidate
        autoComplete="off"
      >
        <TextField
          id="outlined-basic"
          label={name}
          variant={"outlined"}
          fullWidth
          name="form_name"
        />
        <TextField
          id="outlined-basic"
          label={mail}
          variant={"outlined"}
          fullWidth
          name="form_subject"
        />
        <TextField
          id="outlined-basic"
          label={number}
          variant={"outlined"}
          fullWidth
          name="form_mail"
        />
        <TextField
          id="outlined-basic"
          label={subject}
          variant={"outlined"}
          fullWidth
          name="form_number"
        />
        <TextField
          id="outlined-basic"
          label={message}
          variant={"outlined"}
          name="form_message"
          rows={4}
          fullWidth
          multiline
        />
        <Button type="submit" style={{ float: "right" }}>
          {post}
        </Button>
      </Box>
    </div>
  );
};
